import ChangePasswordModal from './container/changePasswordModalContainer';

export default ChangePasswordModal;
